import { useQuery } from '@tanstack/react-query'

import api from '@/lib/api'
import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'
import { Darf } from './useCreateDarfs'

export function useFetchDarfsByApuracaoCompetencia(id_apuracao_competencia: string) {
  const token = useAccessToken()
  const user = useCurrentUser()

  return useQuery({
    queryKey: ['darfs', 'apuracao', id_apuracao_competencia],
    enabled: !!id_apuracao_competencia?.trim() && !!token && !!user,
    queryFn: async (): Promise<Darf[]> => {
      if (!id_apuracao_competencia?.trim()) {
        throw new Error('id_apuracao_competencia é obrigatório')
      }

      if (!user || !token) {
        throw new Error('Usuário não autenticado')
      }

      const response = await api.get<Darf[]>(
        `/darfs/apuracao/${id_apuracao_competencia}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      )

      return Array.isArray(response.data) ? response.data : []
    }
  })
}